import CurrencySpan from "../Currency/CurrencySpan";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import Table from "../../elements/Table/Table";
import _ from "lodash-es";
import moment from "moment";
import { FIXED2 } from "../../tools/fixedTools";

// const aggregatedColor = "DarkGray";

export default class ChartTab extends React.Component {
  render() {
    const { currency, data, pivots } = this.props;
    const selectedYear = this.props.currentYear.year;

    if (!data) {
      return <Spinner size="lg" fullScreen />;
    }
    const totalPreviousAmount =
      data && _.round(_.sum(_.map(data, d => d.previousYearAmount)), 2);
    const totalCurrentAmount =
      data && _.round(_.sum(_.map(data, d => d.currentYearAmount)), 2);
    const totalamountVariation =
      data && _.round(_.sum(_.map(data, d => d.amountVariation)), 2);

    const totalPreviousQuantity =
      data && _.round(_.sum(_.map(data, d => d.previousYearQuantity)), 2);
    const totalCurrentQuantity =
      data && _.round(_.sum(_.map(data, d => d.currentYearQuantity)), 2);
    const totalquantityVariation =
      data && _.round(_.sum(_.map(data, d => d.quantityVariation)), 2);

    const totalbudgetVariation =
      data && _.round(_.sum(_.map(data, d => d.budgetVariation)), 2);


    const totalp1Amount =
      data && _.round(_.sum(_.map(data, d => d.p1Amount)), 2);
    const totalp2Amount =
      data && _.round(_.sum(_.map(data, d => d.p2Amount)), 2);

    // const totalBaseHT = data && _.round(_.sum(_.map(data, d => d.baseHT)), 2);
    const totalAmount = data && _.round(_.sum(_.map(data, d => d.amount)), 2);
    const totalRealValue =
      data && _.round(_.sum(_.map(data, d => d.realValue)), 2);

    const currentYear = new Date().getFullYear();
    const totalPreviousYearRealValue =
      data &&
      _.round(
        _.sum(
          _.map(
            data,
            // d => d.previousYearRealValue
            d =>
              data && data[0]
                ? selectedYear > currentYear
                  ? d.previousYearBudgetAmount
                  : d.previousYearRealValue
                : 0.0
          )
        ),
        2
      );

    if (!data) {
      return <div>no data</div>;
    }

    const cols =
      (this.props.showColumns &&
        _.map(this.props.showColumns, colName => {
          switch (colName) {
            case "family":
              return {
                name: "family",
                id: "family",
                type: "string",
                accessor: d => {
                  const res =
                    (d.category &&
                      d.category.categoryFamily &&
                      d.category.categoryFamily.name) ||
                    "N_A";
                  return res;
                },
                maxWidth: 250,
                // aggregate: vals => _.round(_.sum(vals), 2),
                Aggregated: row => {
                  return <React.Fragment />;
                }
                // Footer: (
                //   <span style={{ textAlign: "right" }}>
                //     <strong>Total:</strong>{" "}
                //   </span>
                // )
              };
            case "tiers":
              return {
                name: "tiers",
                id: "tiers",
                type: "string",
                accessor: d => {
                  return (d.tiers && d.tiers.name) ||
                    (d.bankTransaction && d.bankTransaction.bankAccount && d.bankTransaction.bankAccount.name) ||
                    "N_A";
                },
                maxWidth: 200
              };
            case "tiersAsClient":
              return {
                name: "client",
                id: "tiers",
                type: "string",
                accessor: d => (d.tiers && d.tiers.name) || "N_A",
                maxWidth: 220,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "tiersAsSupplier":
              return {
                name: "supplier",
                id: "tiers",
                type: "string",
                accessor: d => (d.tiers && d.tiers.name) || "N_A",
                maxWidth: 220,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "tiersAsClientAndCategory":
              return {
                name: "tiers",
                id: "tiers",
                type: "string",
                accessor: d =>
                  (d.tiers && d.tiers.name) ||
                  (d.category && d.category.name) ||
                  "N_A",
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "category":
              return {
                name: "category",
                id: "category",
                type: "string",
                accessor: d => {
                  return (d.category && d.category.name) || "N_A";
                },
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "project":
              return {
                name: "project",
                id: "project",
                type: "string",
                accessor: d => (d.project && d.project.name) || "N_A",
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "client":
              return {
                name: "client",
                id: "client",
                type: "string",
                accessor: d => {
                  // console.log("d", d);
                  return (d.client && d.client.name) || "N_A";
                },
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "tiersClient":
              return {
                name: "client",
                id: "tiersClient",
                type: "string",
                accessor: d => {
                  if (d.tiersClient && d.tiersClient.name) {
                    return d.tiersClient.name;
                  }
                  if (d.tiers && d.tiers.client && d.tiers.client.id) {
                    return d.tiers.name;
                  }
                  if (d.project && d.project.tiersClient && d.project.tiersClient.name) {
                    return d.project.tiersClient.name;
                  }
                  // console.log("184 - d=", d);
                  // console.log("185 - return", "N_A");
                  return "N_A";
                },
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "tiersName":
              return {
                name: "tiers",
                id: "tiersName",
                type: "string",
                accessor: d => (d.tiers && d.tiers.name) || "N_A",
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "tiersGroup":
              return {
                name: "group",
                id: "tiersGroup",
                type: "string",
                accessor: d => (d.tiers && d.tiers.group) || "N_A",
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "seller":
              return {
                name: "seller",
                id: "seller",
                type: "string",
                accessor: d => {
                  const str =
                    (d.invoice &&
                      d.invoice.vendeur &&
                      d.invoice.vendeur.name) ||
                    "N_A";
                  // console.log("invoice=", str);
                  return str;
                },
                maxWidth: 250,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "hiddenSeller":
              return {
                name: "seller",
                visible: false,
                id: "hiddenSeller",
                type: "string",
                accessor: d => {
                  const str =
                    (d.invoice &&
                      d.invoice.vendeur &&
                      d.invoice.vendeur.name) ||
                    "N_A";
                  // console.log("invoice=", str);
                  return str;
                },
                maxWidth: 250,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "hiddenCommercial":
              return {
                name: "respComm",
                visible: false,
                id: "hidden_respComm",
                type: "string",
                accessor: d => {

                  // if (d.tiers &&
                  //   d.tiers.client &&
                  //   d.tiers.client.collaboratorRespCom) {

                  //   console.log("270 - d=", d.tiers &&
                  //     d.tiers.client &&
                  //     d.tiers.client.collaboratorRespCom);
                  // }

                  const str =
                    (d.tiers &&
                      d.tiers.client &&
                      d.tiers.client.collaboratorRespCom &&
                      d.tiers.client.collaboratorRespCom.tiers &&
                      d.tiers.client.collaboratorRespCom.tiers.name) ||
                    "";

                  // console.log("invoice=", str);
                  return str;
                },
                maxWidth: 250,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "vendeur":
              return {
                name: "seller",
                id: "vendeur",
                type: "string",
                accessor: d => {
                  const str =
                    (d.vendeur &&
                      d.vendeur.name) ||
                    "N_A";
                  // console.log("invoice=", str);
                  return str;
                },
                maxWidth: 250,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "product":
              return {
                name: "product",
                id: "product",
                type: "string",
                accessor: d => (d.article && d.article.name) || "N_A",
                maxWidth: 200,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "dateMonthYear":
              return {
                name: "month",
                id: "dateMonthYear",
                type: "string",
                accessor: d => {
                  const date = d.dateMonthYear || "N_A"; //moment(d.date).format("YYYY-MM"); //d.dateMonthYear;
                  return date;
                },
                maxWidth: 130,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "paymentDate":
              return {
                name: "paymentDate",
                id: "paymentDate",
                type: "string",
                accessor: d => moment(d.paymentDate).format("L"),
                maxWidth: 120,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "operationDate":
              return {
                name: "operationDate",
                id: "operationDate",
                type: "string",
                accessor: d => moment(d.operationDate).format("L"),
                maxWidth: 120,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            case "date":
              return {
                name: "date",
                id: "date",
                type: "string",
                accessor: d => moment(d.date).format("L"),
                maxWidth: 180,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "type":
              return {
                name: "type",
                id: "type",
                accessor: d => d.type,
                maxWidth: 210,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };

            // case "quantity":
            //   return {
            //     name: "quantity",
            //     id: "quantity",
            //     type: "string",
            //     accessor: d => (d.article && d.article.quantity) || "N_A",
            //     maxWidth: 200,
            //     Aggregated: row => {
            //       return <React.Fragment />;
            //     }
            //   };

            case "taxLabel":
              return {
                name: "tax",
                id: "taxLabel",
                type: "string",
                accessor: d => d.taxLabel || "N_A",
                maxWidth: 120,
                // expanded: true,
                Aggregated: row => {
                  return <React.Fragment />;
                }
              };
            case "taxTaux":
              return {
                name: "taux",
                id: "taxTaux",
                type: "numeric",
                accessor: d =>
                  (!!!isNaN(d.taxTaux) && d.taxTaux + " %") || "0 %" || "N_A",
                maxWidth: 110
                // Aggregated: row => {
                //   return <React.Fragment />;
                // }
              };
            case "baseHT":
              return {
                name: "ht",
                id: "baseHT",
                type: "currency",
                accessor: d => d.baseHT || 0,
                maxWidth: 100,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={2} value={row.value} />
                  </div>
                )
                // Footer: <strong>{<CurrencySpan value={totalBaseHT} />}</strong>
              };
            case "amount":
              return {
                name: "amount",
                id: "amount",
                type: "currency",
                accessor: d => d.amount || 0.0,
                maxWidth: 100,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={2} value={row.value} />
                  </div>
                ),
                Footer: <b>{<CurrencySpan value={totalAmount} />}</b>
              };

            case "taxTotalTTC":
              return {
                visible: false,
                name: "amountTTC",
                id: "amountTTC",
                type: "currency",
                accessor: d => FIXED2(d.amount + d.baseHT) || 0.0,
                maxWidth: 100,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={2} value={row.value} />
                  </div>
                ),
                // Footer: <b>{<CurrencySpan value={totalAmount} />}</b>
              };

            case "budget":
              return {
                noTranslateColumnName: true,
                name: `${this.props.intl.formatMessage({
                  id: "ids_budg" //id: "ids_budget"
                })} ${selectedYear}`,
                id: "budget",
                type: "currency",
                digit: 0,
                accessor: d => d.amount || 0.0,
                maxWidth: 120,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={0} value={row.value} />
                  </div>
                ),
                Footer: <b>{<CurrencySpan digit={0} value={totalAmount} />}</b>
              };

            case "realValue":
              return {
                // name: "realValue",
                noTranslateColumnName: true,
                name: `${this.props.intl.formatMessage({
                  id: "ids_real"
                })} ${selectedYear}`,
                id: "realValue",
                type: "currency",
                digit: 0,
                accessor: d => d.realValue || 0.0,
                maxWidth: 100,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={0} value={row.value} />
                  </div>
                ),
                Footer: (
                  <b>{<CurrencySpan digit={0} value={totalRealValue} />}</b>
                )
              };

            case "previousYearRealValueOrBudget":
              return {
                noTranslateColumnName: true,
                name:
                  selectedYear > currentYear
                    ? `${this.props.intl.formatMessage({
                      id: "ids_budg" //id: "ids_budget"
                    })} ${selectedYear - 1}`
                    : `${this.props.intl.formatMessage({
                      id: "ids_real"
                    })} ${selectedYear - 1}`,
                id: "previousYearRealValue",
                type: "currency",
                digit: 0,
                accessor: d =>
                  data && data[0]
                    ? selectedYear > currentYear
                      ? d.previousYearBudgetAmount
                      : d.previousYearRealValue
                    : 0.0,

                maxWidth: selectedYear > currentYear
                  ? 120
                  : 100,
                aggregate: vals => {
                  const sum = _.round(_.sum(vals), 2);
                  return sum;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={0} value={row.value} />
                  </div>
                ),
                Footer: (
                  <b>
                    {
                      <CurrencySpan
                        digit={0}
                        value={totalPreviousYearRealValue}
                      />
                    }
                  </b>
                )
              };

            case "budgetVariation":
              return {
                id: "budgetVariation",
                name: "variation",
                accessor: d => d.budgetVariation || 0.0,
                type: "currency",
                digit: 0,
                noTextColor: true,
                aggregate: vals => _.sum(vals),
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={0} value={row.value} />
                  </div>
                ),
                // Cell: () => <div />,
                Footer: (
                  <b>
                    {<CurrencySpan digit={0} value={totalbudgetVariation} />}
                  </b>
                )
              };

            case "budgetVariationPourcent":
              return {
                id: "budgetVariationPourcent",
                name: "pourcent",
                accessor: d => d.budgetVariationPourcent || 0.0,
                type: "currency",
                aggregate: (vals, rows) => {
                  const budgetSum = _.sum(_.map(rows, d => d.budget));
                  const variationSum = _.sum(
                    _.map(rows, d => d.budgetVariation)
                  );

                  const ret =
                    variationSum !== 0 && budgetSum !== 0
                      ? _.round((variationSum / budgetSum) * 100.0, 2)
                      : 0.0;
                  // console.log("budget=", budgetSum, "var=", variationSum, "Res=", ret);
                  return ret;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={2} value={row.value} />
                  </div>
                ),
                // Cell: () => <div />,
                maxWidth: 60
              };

            case "amountPerfVariation":
              return {
                id: "amountPerfVariation",
                name: "variation",
                accessor: d => d.amountVariation,
                // type: "currency",
                currency: currency,
                noTextColor: true,
                textAlign: "right",
                aggregate: vals => _.sum(vals),
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    <CurrencySpan digit={2} value={row.value} />
                  </div>
                ),
                Cell: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      textAlign: "right"
                    }}
                  >
                    {_.round(row.value, 2)
                      // ? (
                      // <CurrencySpan digit={2} value={row.value} />
                      // ) : (
                      // ""
                      // )
                    }
                  </div>
                ),
                maxWidth: 180,
                Footer: <b>{<CurrencySpan value={totalamountVariation} />}</b>
              };
              break;

            case "amountPerfVariationPourcent":
              return {
                id: "amountPerfVariationPourcent",
                name: "pourcent",
                accessor: d => {
                  // if (d.amountVariationPourcent === -100)
                  //   console.log("-----------", d);
                  return d.amountVariationPourcent;
                },
                type: "currency",
                filterable: false,

                aggregate: (vals, rows) => {
                  const p1AmountSum = _.sum(
                    _.map(
                      rows,
                      d => (d._original && d._original.p1Amount) || d.period1
                    )
                  );
                  const p2AmountSum = _.sum(
                    _.map(
                      rows,
                      d => (d._original && d._original.p2Amount) || d.period2
                    )
                  );
                  const variationSum = _.sum(
                    _.map(rows, d => d.amountPerfVariation)
                  );

                  // if (!p1AmountSum && p2AmountSum !== 0) return 100;
                  let v = 100.0;
                  if (p1AmountSum !== 0) {
                    v =
                      // _.round(
                      (variationSum / p1AmountSum) * 100.0;
                    // , 2);
                  }
                  // console.log("593 v: ", p1AmountSum, p2AmountSum, variationSum, v);
                  return v;
                },
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    {_.round(row.value, 2)
                      // ? (
                      // <CurrencySpan digit={2} value={row.value} />
                      // ) : (
                      // ""
                      // )
                    }
                  </div>
                ),
                Cell: row => <div> {row.value} </div>,
                maxWidth: 60,
                // Aggregated: row => {
                //   return _.round(row.value, 2); //row.value ? <span>{row.value}</span> : "";
                // }
                Footer: <b>{
                  totalp1Amount !== 0 ?
                    _.round(((totalamountVariation / totalp1Amount) * 100.0), 2) : 100
                }</b>
              };
              break;

            case "period1":
            case "period2":

              let columnName = colName;
              let noTranslateColumnName = false;
              if (colName === "period1" && this.props.period1Text) {
                columnName = this.props.period1Text;
                noTranslateColumnName = true
              }
              if (colName === "period2" && this.props.period2Text) {
                columnName = this.props.period2Text;
                noTranslateColumnName = true
              }

              return {
                id: colName,
                name: columnName,
                noTranslateColumnName: noTranslateColumnName,
                accessor: d => {
                  // console.log("tot", colName);
                  return d && colName === "period1" ? d.p1Amount : d.p2Amount;
                },
                textAlign: "right",

                aggregate: vals => _.sum(vals),
                Aggregated: row => (
                  <div
                    style={{
                      // color: row.isExpanded ? aggregatedColor : "Inherit",
                      fontWeight: row.isExpanded ? "bold" : "Inherit",
                      textAlign: row.isExpanded ? "left" : "Inherit"
                    }}
                  >
                    {row.value ? (
                      <CurrencySpan digit={2} value={row.value} />
                    ) : (
                      ""
                    )}
                  </div>
                ),
                Cell: row => (
                  <div>
                    {// row.value > 0 ?
                      row.value ? <CurrencySpan value={row.value} /> : ""}
                  </div>
                ),
                maxWidth: 210,
                type: "string",
                // type: "currency",
                currency: currency,
                noTextColor: true,
                // aggregate: vals => _.sum(vals),
                // Aggregated: row => (
                //   <div
                //     style={{
                //       // color: row.isExpanded ? aggregatedColor : "Inherit",
                //       fontWeight: row.isExpanded ? "bold" : "Inherit",
                //       textAlign: row.isExpanded ? "left" : "Inherit"
                //     }}
                //   >
                //     <CurrencySpan digit={2} value={row.value} />
                //   </div>
                // )
                // Cell: row => (
                //   <div>
                //     {// row.value > 0 ?
                //     row.value ? <CurrencySpan value={row.value} /> : ""}
                //   </div>
                // ),
                Footer: (
                  <b>
                    {
                      <CurrencySpan
                        value={
                          colName === "period1" ? totalp1Amount : totalp2Amount
                        }
                      />
                    }
                  </b>
                )
              };
              break;

            // case "previous_quantity":
            //   return {
            //     id: "previousYearQuantity",
            //     name: this.props.intl.formatMessage({ id: 'ids_quantity' }) + " " + this.props.previousYear.title,
            //     noTranslateColumnName: true,
            //     accessor: d => d.previousYearQuantity,
            //     maxWidth: 150,
            //     type: "currency",
            //     filterable: false,
            //     noTextColor: true,
            //     aggregate: vals => _.sum(vals),
            //     Aggregated: row => (
            //       <div
            //         style={{
            //           // color: row.isExpanded ? aggregatedColor : "Inherit",
            //           fontWeight: row.isExpanded ? "bold" : "Inherit",
            //           textAlign: row.isExpanded ? "left" : "Inherit"
            //         }}
            //       >
            //         <span>{row.value}</span>
            //       </div>
            //     ),
            //     Cell: row => (
            //       <div>
            //         {// row.value > 0 ?
            //           row.value ? <span>{row.value}</span> : ""}
            //       </div>
            //     )
            //   }
            //   break;

            // case "current_quantity":
            //   return {
            //     id: "currentYearQuantity",
            //     name: this.props.intl.formatMessage({ id: 'ids_quantity' }) + " " + this.props.currentYear.title,
            //     noTranslateColumnName: true,
            //     accessor: d => d.previousYearQuantity,
            //     maxWidth: 150,
            //     type: "currency",
            //     filterable: false,
            //     noTextColor: true,
            //     aggregate: vals => _.sum(vals),
            //     Aggregated: row => (
            //       <div
            //         style={{
            //           // color: row.isExpanded ? aggregatedColor : "Inherit",
            //           fontWeight: row.isExpanded ? "bold" : "Inherit",
            //           textAlign: row.isExpanded ? "left" : "Inherit"
            //         }}
            //       >
            //         <span>{row.value}</span>
            //       </div>
            //     ),
            //     Cell: row => (
            //       <div>
            //         {// row.value > 0 ?
            //           row.value ? <span>{row.value}</span> : ""}
            //       </div>
            //     )
            //   }
            //   break;

            default:
              break;
          }
        })) ||
      undefined;

    let visibleColumns = [];
    cols && visibleColumns.push(...cols);
    this.props.visibleColumns &&
      visibleColumns.push(...this.props.visibleColumns);

    // if (this.props.type !== "taxes")
    if (this.props.showDetails) {
      visibleColumns.push(
        // add preconfigured columns
        // ...cols,
        {
          name: "details",
          id: "details",
          type: "string",
          accessor: d =>
            (d.invoice && d.invoice.numeroPiece) ||
            (d.expense && d.expense.numeroPiece),
          maxWidth: 300,
          Aggregated: () => <div />,
          Cell: row => {
            if (row.aggregated) return null;
            const numeroPiece =
              (row.original.invoice && row.original.invoice.numeroPiece) ||
              (row.original.expense && row.original.expense.numeroPiece) ||
              undefined;

            // const creator =
            //   (row.original.expense &&
            //     row.original.expense.creator &&
            //     row.original.expense.creator.name) ||
            //   undefined;

            const date = moment(row.original.dateOperation).format("L");

            // fetch bank transaction libelle
            const libelle =
              (row.original.bankTransaction &&
                row.original.bankTransaction.libelleLong) ||
              "";
            const text =
              (numeroPiece !== undefined ? numeroPiece + " - " : "") +
              // +
              // creator !== undefined
              // ? creator
              // : ""
              `${date} - ${libelle}`;
            return <div title={text}>{text}</div>;
          },
          export: row => {
            // console.log("513 - ROW=", row) ;
            const numeroPiece =
              (row.invoice && row.invoice.numeroPiece) ||
              (row.expense && row.expense.numeroPiece) ||
              undefined;

            const date = moment(row.dateOperation).format("L");

            // fetch bank transaction libelle
            const libelle =
              (row.bankTransaction && row.bankTransaction.libelleLong) || "";
            const text =
              (numeroPiece !== undefined ? numeroPiece + " - " : "") +
              `${date} - ${libelle}`;

            return text;
          }
        },

        // ...(this.props.type === "sales" ? [        
        // {
        //   id: "previousYearQuantity",
        //   name: this.props.intl.formatMessage({ id: 'ids_quantity'}) + " " + this.props.previousYear.title,
        //   noTranslateColumnName: true,
        //   accessor: d => d.previousYearQuantity,
        //   maxWidth: 150,
        //   type: "currency",
        //   filterable: false,
        //   noTextColor: true,
        //   aggregate: vals => _.sum(vals),
        //   Aggregated: row => (
        //     <div
        //       style={{
        //         // color: row.isExpanded ? aggregatedColor : "Inherit",
        //         fontWeight: row.isExpanded ? "bold" : "Inherit",
        //         textAlign: row.isExpanded ? "left" : "Inherit"
        //       }}
        //     >
        //       <span>{row.value}</span>
        //     </div>
        //   ),
        //   Cell: row => (
        //     <div>
        //       {// row.value > 0 ?
        //         row.value ? <span>{row.value}</span> : ""}
        //     </div>
        //   )
        // }] : []),

        {
          id: "previousYearAmount",
          name: this.props.previousYear.title,
          accessor: d => d.previousYearAmount,
          maxWidth: 100,
          type: "currency",
          currency: currency,
          noTextColor: true,
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: row => (
            <div>
              {// row.value > 0 ?
                row.value ? <CurrencySpan value={row.value} /> : ""}
            </div>
          ),
          Footer: <b>{<CurrencySpan value={totalPreviousAmount} />}</b>
        },
        {
          id: "previousYearPercent",
          name: `pourcent`,
          accessor: d => d.previousYearAmount,
          type: "currency",
          filterable: false,
          aggregate: (vals, rows) => {
            const prevYearAmountSum = _.sum(
              _.map(rows, d => d.previousYearAmount)
            );
            const t =
              totalPreviousAmount !== 0.0
                ? _.round((prevYearAmountSum / totalPreviousAmount) * 100.0, 2)
                : "";
            return t;
          },
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: row => {
            if (row.aggregated && row.value !== 0.0)
              return <CurrencySpan value={row.value} />;
            if (row.value) {
              const t = (row.value / totalPreviousAmount) * 100.0;
              return <CurrencySpan value={t} />;
            }
            return null;
          },
          maxWidth: 60
        },

        // ...(this.props.type === "sales" ? [        
        //   {
        //     id: "currentYearQuantity",
        //     name: this.props.intl.formatMessage({ id: 'ids_quantity'}) + " " + this.props.currentYear.title,
        //     noTranslateColumnName: true,
        //     accessor: d => d.currentYearQuantity,
        //     maxWidth: 150,
        //     type: "currency",
        //     filterable: false,
        //     noTextColor: true,
        //     aggregate: vals => _.sum(vals),
        //     Aggregated: row => (
        //       <div
        //         style={{
        //           // color: row.isExpanded ? aggregatedColor : "Inherit",
        //           fontWeight: row.isExpanded ? "bold" : "Inherit",
        //           textAlign: row.isExpanded ? "left" : "Inherit"
        //         }}
        //       >
        //         <span>{row.value}</span>
        //       </div>
        //     ),
        //     Cell: row => (
        //       <div>
        //         {// row.value > 0 ?
        //           row.value ? <span>{row.value}</span> : ""}
        //       </div>
        //     )
        //   }] : []),

        {
          id: "currentYearAmount",
          name: this.props.currentYear.title,
          accessor: d => d.currentYearAmount,
          type: "currency",
          currency: currency,
          noTextColor: true,
          Cell: row => {
            // row.value > 0 ?
            return <CurrencySpan value={row.value} />;
            //  : ""
          },
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          maxWidth: 100,
          Footer: (
            <b>
              <CurrencySpan value={totalCurrentAmount} />
            </b>
          )
        },
        {
          id: "currentYearPercent",
          name: `pourcent`,
          accessor: d => d.currentYearAmount,
          type: "currency",
          filterable: false,

          // Aggregated: row => {
          //   return <span />;
          // },
          aggregate: (vals, rows) => {
            const currentYearAmountSum = _.sum(
              _.map(rows, d => d.currentYearAmount)
            );
            return totalCurrentAmount !== 0.0
              ? _.round((currentYearAmountSum / totalCurrentAmount) * 100.0, 2)
              : "";
          },

          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: row => {
            if (row.aggregated && row.value !== 0.0)
              return <CurrencySpan value={row.value} />;
            if (row.value) {
              const t =
                totalCurrentAmount !== 0
                  ? _.round((row.value / totalCurrentAmount) * 100.0, 2)
                  : 0.0;
              // const t = _.round((row.value / totalCurrentAmount) * 100.0, 2);
              return <CurrencySpan value={t} />;
            }
            return null;
          },
          maxWidth: 60
        },
        {
          id: "amountVariation",
          name: "variation",
          accessor: d => d.amountVariation,
          type: "currency",
          currency: currency,
          noTextColor: true,
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: () => <div />,
          Footer: <b>{<CurrencySpan value={totalamountVariation} />}</b>
        },
        {
          id: "amountVariationPourcent",
          name: "pourcent",
          accessor: d => d.amountVariationPourcent,
          type: "currency",
          filterable: false,

          aggregate: (vals, rows) => {
            const prevYearAmountSum = _.sum(
              _.map(rows, d => d.previousYearAmount)
            );
            const variationSum = _.sum(_.map(rows, d => d.amountVariation));

            if (prevYearAmountSum !== 0)
              return _.round((variationSum / prevYearAmountSum) * 100.0, 2);
            return 0.0;
          },
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: () => <div />,
          maxWidth: 60
          // Aggregated: row => {
          //   return <span>{row.value}</span>;
          // }
        }
      )
    }

    if (this.props.showQuantityDetails) {
      visibleColumns.push(
        // add preconfigured columns
        // ...cols,
        {
          name: "details",
          id: "details",
          type: "string",
          accessor: d =>
            (d.invoice && d.invoice.numeroPiece) ||
            (d.expense && d.expense.numeroPiece),
          maxWidth: 300,
          Aggregated: () => <div />,
          Cell: row => {
            if (row.aggregated) return null;
            const numeroPiece =
              (row.original.invoice && row.original.invoice.numeroPiece) ||
              (row.original.expense && row.original.expense.numeroPiece) ||
              undefined;

            // const creator =
            //   (row.original.expense &&
            //     row.original.expense.creator &&
            //     row.original.expense.creator.name) ||
            //   undefined;

            const date = moment(row.original.dateOperation).format("L");

            // fetch bank transaction libelle
            const libelle =
              (row.original.bankTransaction &&
                row.original.bankTransaction.libelleLong) ||
              "";
            const text =
              (numeroPiece !== undefined ? numeroPiece + " - " : "") +
              // +
              // creator !== undefined
              // ? creator
              // : ""
              `${date} - ${libelle}`;
            return <div title={text}>{text}</div>;
          },
          export: row => {
            // console.log("513 - ROW=", row) ;
            const numeroPiece =
              (row.invoice && row.invoice.numeroPiece) ||
              (row.expense && row.expense.numeroPiece) ||
              undefined;

            const date = moment(row.dateOperation).format("L");

            // fetch bank transaction libelle
            const libelle =
              (row.bankTransaction && row.bankTransaction.libelleLong) || "";
            const text =
              (numeroPiece !== undefined ? numeroPiece + " - " : "") +
              `${date} - ${libelle}`;

            return text;
          }
        },

        // ...(this.props.type === "sales" ? [        
        {
          id: "previousYearQuantity",
          name: this.props.intl.formatMessage({ id: 'ids_quantity' }) + " " + this.props.previousYear.title,
          noTranslateColumnName: true,
          accessor: d => d.previousYearQuantity,
          maxWidth: 150,
          type: "currency",
          filterable: false,
          noTextColor: true,
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <span>{row.value}</span>
            </div>
          ),
          Cell: row => (
            <div>
              {// row.value > 0 ?
                row.value ? <span>{row.value}</span> : ""}
            </div>
          )
        },
        //] : []),

        // {
        //   id: "previousYearAmount",
        //   name: this.props.previousYear.title,
        //   accessor: d => d.previousYearAmount,
        //   maxWidth: 100,
        //   type: "currency",
        //   currency: currency,
        //   noTextColor: true,
        //   aggregate: vals => _.sum(vals),
        //   Aggregated: row => (
        //     <div
        //       style={{
        //         // color: row.isExpanded ? aggregatedColor : "Inherit",
        //         fontWeight: row.isExpanded ? "bold" : "Inherit",
        //         textAlign: row.isExpanded ? "left" : "Inherit"
        //       }}
        //     >
        //       <CurrencySpan digit={2} value={row.value} />
        //     </div>
        //   ),
        //   Cell: row => (
        //     <div>
        //       {// row.value > 0 ?
        //         row.value ? <CurrencySpan value={row.value} /> : ""}
        //     </div>
        //   ),
        //   Footer: <b>{<CurrencySpan value={totalPreviousAmount} />}</b>
        // },
        {
          id: "previousYearPercent",
          name: `pourcent`,
          accessor: d => d.previousYearQuantity,
          type: "currency",
          filterable: false,
          aggregate: (vals, rows) => {
            const prevYearQuantitySum = _.sum(
              _.map(rows, d => d.previousYearQuantity)
            );
            const t =
              totalPreviousQuantity !== 0.0
                ? _.round((prevYearQuantitySum / totalPreviousQuantity) * 100.0, 2)
                : "";
            return t;
          },
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: row => {
            if (row.aggregated && row.value !== 0.0)
              return <CurrencySpan value={row.value} />;
            if (row.value) {
              const t = (row.value / totalPreviousQuantity) * 100.0;
              return <CurrencySpan value={t} />;
            }
            return null;
          },
          maxWidth: 60
        },

        // ...(this.props.type === "sales" ? [        
        {
          id: "currentYearQuantity",
          name: this.props.intl.formatMessage({ id: 'ids_quantity' }) + " " + this.props.currentYear.title,
          noTranslateColumnName: true,
          accessor: d => d.currentYearQuantity,
          maxWidth: 150,
          type: "currency",
          filterable: false,
          noTextColor: true,
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <span>{row.value}</span>
            </div>
          ),
          Cell: row => (
            <div>
              {// row.value > 0 ?
                row.value ? <span>{row.value}</span> : ""}
            </div>
          )
        },    //] : []),

        // {
        //   id: "currentYearAmount",
        //   name: this.props.currentYear.title,
        //   accessor: d => d.currentYearAmount,
        //   type: "currency",
        //   currency: currency,
        //   noTextColor: true,
        //   Cell: row => {
        //     // row.value > 0 ?
        //     return <CurrencySpan value={row.value} />;
        //     //  : ""
        //   },
        //   aggregate: vals => _.sum(vals),
        //   Aggregated: row => (
        //     <div
        //       style={{
        //         // color: row.isExpanded ? aggregatedColor : "Inherit",
        //         fontWeight: row.isExpanded ? "bold" : "Inherit",
        //         textAlign: row.isExpanded ? "left" : "Inherit"
        //       }}
        //     >
        //       <CurrencySpan digit={2} value={row.value} />
        //     </div>
        //   ),
        //   maxWidth: 100,
        //   Footer: (
        //     <b>
        //       <CurrencySpan value={totalCurrentAmount} />
        //     </b>
        //   )
        // },
        {
          id: "currentYearPercent",
          name: `pourcent`,
          accessor: d => d.currentYearQuantity,
          type: "currency",
          filterable: false,

          // Aggregated: row => {
          //   return <span />;
          // },
          aggregate: (vals, rows) => {
            const currentYearQuantitySum = _.sum(
              _.map(rows, d => d.currentYearQuantity)
            );
            return totalCurrentQuantity !== 0.0
              ? _.round((currentYearQuantitySum / totalCurrentQuantity) * 100.0, 2)
              : "";
          },

          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: row => {
            if (row.aggregated && row.value !== 0.0)
              return <CurrencySpan value={row.value} />;
            if (row.value) {
              const t =
                totalCurrentQuantity !== 0
                  ? _.round((row.value / totalCurrentQuantity) * 100.0, 2)
                  : 0.0;
              // const t = _.round((row.value / totalCurrentQuantity) * 100.0, 2);
              return <CurrencySpan value={t} />;
            }
            return null;
          },
          maxWidth: 60
        },
        {
          id: "quantityVariation",
          name: "variation",
          accessor: d => d.quantityVariation,
          type: "currency",
          currency: currency,
          noTextColor: true,
          aggregate: vals => _.sum(vals),
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: () => <div />,
          Footer: <b>{<CurrencySpan value={totalquantityVariation} />}</b>
        },
        {
          id: "quantityVariationPourcent",
          name: "pourcent",
          accessor: d => d.quantityVariationPourcent,
          type: "currency",
          filterable: false,

          aggregate: (vals, rows) => {
            const prevYearQuantitySum = _.sum(
              _.map(rows, d => d.previousYearQuantity)
            );
            const variationSum = _.sum(_.map(rows, d => d.quantityVariation));

            if (prevYearQuantitySum !== 0)
              return _.round((variationSum / prevYearQuantitySum) * 100.0, 2);
            return 0.0;
          },
          Aggregated: row => (
            <div
              style={{
                // color: row.isExpanded ? aggregatedColor : "Inherit",
                fontWeight: row.isExpanded ? "bold" : "Inherit",
                textAlign: row.isExpanded ? "left" : "Inherit"
              }}
            >
              <CurrencySpan digit={2} value={row.value} />
            </div>
          ),
          Cell: () => <div />,
          maxWidth: 60
          // Aggregated: row => {
          //   return <span>{row.value}</span>;
          // }
        }
      )
    }

    if (this.props.showExtra) {
      visibleColumns.push(
        // add preconfigured columns
        // ...cols,
        // {
        //   id: "year",
        //   visible: false,
        //   name: "year",
        //   type: "string",
        //   accessor: d => {
        //     if (d.dateOperation)
        //       return moment(d.dateOperation).format("YYYY");
        //     else if (d.dateMonthYear)
        //       return d.dateMonthYear.substring(0, 4);
        //   },
        //   export: d => {
        //     // console.log('1072 - d=', d);
        //     if (d.dateOperation)
        //       return moment(d.dateOperation).format("YYYY");
        //     else if (d.dateMonthYear)
        //       return d.dateMonthYear.substring(0, 4);
        //   }
        // },
        {
          id: "month",
          visible: false,
          name: "month",
          type: "string",
          accessor: d => {
            if (d.dateOperation)
              return moment(d.dateOperation).format("MM");
            else if (d.dateMonthYear)
              return d.dateMonthYear.substring(5, 7);
            else
              return "";
          },
          export: d => {
            if (d.dateOperation)
              return moment(d.dateOperation).format("MM");
            else if (d.dateMonthYear)
              return d.dateMonthYear.substring(5, 7);
            else
              return "";
          }
        },
        {
          id: "day",
          visible: false,
          name: "day",
          type: "string",
          accessor: d => {
            if (d.dateOperation)
              return moment(d.dateOperation).format("DD");
            else
              return "";
          },
          export: d => {
            if (d.dateOperation)
              return moment(d.dateOperation).format("DD");
            else
              return "";
          }
        },
        {
          id: "cumul",
          visible: false,
          name: "sumAmount",
          type: "currency",
          accessor: d => {
            if (d.currentYearAmount && d.previousYearAmount)
              return FIXED2(d.currentYearAmount + d.previousYearAmount)
            else
              return "";
          },
          export: d => {
            // console.log("1137 - d=", d);
            if (d.currentYearAmount !== undefined || d.previousYearAmount !== undefined) {
              let cumul = FIXED2(d.currentYearAmount + d.previousYearAmount)
              cumul = cumul.toString();
              cumul = cumul.replace(".", ",");
              return cumul;
            }
            else
              return "";
          },
        },
        {
          id: "group",
          visible: false,
          name: "group",
          type: "string",
          accessor: d => {
            if (d.tiers !== undefined && d.tiers !== null) {
              return d.tiers.group;
            }
            else
              return "";
          },
          export: d => {
            if (d.tiers !== undefined && d.tiers !== null) {
              return d.tiers.group;
            }
            else
              return "";
          }
        }
      )
    };

    return (
      <div>
        {" "}
        {
          this.props.currentYearData && (
            <h3>
              {Object.keys(this.props.currentYearData)[this.props.selectedPeriod]}
            </h3>
          )
        }
        {
          <Table
            // expandAll={true}
            // dataSelectedCount={["totalHT", "totalTTC"]}
            tableName="reports"
            type={this.props.type}
            visibleColumns={visibleColumns}
            data={data || []}
            pivotBy={pivots}
            defaultPageSize={this.props.defaultPageSize}
            onRowClick={this.props.onRowClick ? this.props.onRowClick : alert}
            expanded={this.props.expanded}
            showPagination={this.props.showPagination}
            onExpandedChange={this.props.onExpandedChange}
            fixHeight={true}
            defaultSorted={this.props.defaultSorted || []}
            showFilter={this.props.showFilter}
          />
        }
      </div >
    );
  }
}
